import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import Sidebar from "../Sidebar";
import "../../styles/theme.css";
import "../../styles/HelpPage.css";
import { useSidebar } from "../../App";

export default function Help() {
  // Get sidebar collapse state from context
  const { sidebarCollapsed } = useSidebar();

  // PDF file path (must be in public/ folder)
  // Change to "/wh_ai_help_guide14.pdf" if your file name is different
  const pdfUrl = "/wh_ai_help_guide16.pdf";

  // PDF viewer parameters to hide as much UI as possible
  const viewerParams = "#toolbar=0&navpanes=0&pagemode=none&scrollbar=1&view=FitH&statusbar=0";

  return (
    <div className="theme-whbl">
      <Header />

      <div className="container-fluid">
        <div className="main-container">
          {/* Sidebar column */}
          <div className={`${sidebarCollapsed ? 'col-1' : 'col-2'} p-0`}>
            <Sidebar />
          </div>

          {/* Main content area */}
          <main
            className={`main-content ${sidebarCollapsed ? 'col-11' : 'col-10'}`}
            style={{
              width: "100%",
              overflowX: "hidden",
              overflowY: "auto",
              height: "calc(100vh - 70px)", // Adjust according to your header height
            }}
          >
            <div
              className="dashboard p-4"
              style={{
                minHeight: "100%",
                background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                borderRadius: "12px",
                margin: "1rem",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              }}
            >
              <div style={{ marginBottom: "1rem" }}>
                <Link
                  to="/help"
                  className="btn btn-secondary"
                  style={{ textDecoration: "none" }}
                >
                  ← Back to Help
                </Link>
              </div>

              {/* Page title */}
              <h2
                className="mb-5 text-center"
                style={{
                  color: "#f8fafc",
                  fontWeight: "bold",
                  // textShadow: "0 2px 8px rgba(96,165,250,0.4)",
                }}
              >
                WhiteHaX Help Guide
              </h2>

              {/* PDF viewer container */}
              <div
                style={{
                  width: "100%",
                  maxWidth: "960px",
                  margin: "0 auto",
                  height: "calc(100vh - 180px)",
                  border: "1px solid #334155",
                  borderRadius: "12px",
                  overflow: "hidden",
                  background: "#0f172a",
                  boxShadow: "inset 0 0 15px rgba(0,0,0,0.6)",
                }}
              >
                <iframe
                  src={`${pdfUrl}${viewerParams}`}
                  width="100%"
                  height="100%"
                  title="WhiteHaX Help Guide"
                  style={{ border: "none", display: "block" }}
                  allowFullScreen
                />
              </div>

              {/* Simple fallback link using existing .helpBtn class */}
              <div className="text-center mt-6">
                <p className="text-gray-400 text-sm mb-3">
                  Not loading properly?
                </p>
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="helpBtn"
                >
                  Open PDF in New Tab
                </a>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}